import { createSelector } from 'reselect';
import { civilClubsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const civilClubsYearsSelector = createSelector([civilClubsSelector], (civilClubs) =>
  extractDatesFromNestedItems(
    [civilClubs.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
